import { spacing, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { min } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-cluster";
const pillBase = {
  ...min,
  display: "inline-block",
  padding: `${spacing.min} ${spacing.xs}`,
  marginBottom: "0",
  marginTop: spacing.min,
  transition: "background-color 0.3s",
  "& > span": {
    display: "flex",
    gap: "4px",
    whiteSpace: "nowrap"
  }
};
const pillSvg = {
  height: "12px",
  width: "12px"
};
function composePill(options) {
  const { theme = "light" } = options || {};
  let composed = {
    marginTop: `-${spacing.min}`,
    "& > *": {
      ...pillBase
    },
    "& svg": {
      ...pillSvg
    }
  };
  if (theme === "light") {
    composed = {
      ...composed,
      "& > *": {
        ...composed["& > *"],
        backgroundColor: color.gray.lightest
      },
      "& a:hover, & a:focus": {
        backgroundColor: color.gold
      }
    };
  } else if (theme === "dark") {
    composed = {
      ...composed,
      "& > *": {
        ...composed["& > *"],
        backgroundColor: color.gray.dark,
        color: color.white
      },
      "& svg": {
        ...pillSvg,
        fill: color.white
      },
      "& a:hover, & a:focus": {
        backgroundColor: color.gray.lighter,
        color: color.black,
        "& svg": {
          fill: color.black
        }
      }
    };
  }
  const className = theme === "dark" ? `${classNamePrefix}-pill-dark` : `${classNamePrefix}-pill`;
  const deprecatedAliases = theme === "dark" ? ["umd-pill-list-dark"] : ["umd-pill-list"];
  return objectWithClassName({
    ...composed,
    className: [className, ...deprecatedAliases]
  });
}
const pillList = composePill();
const pillListDark = composePill({ theme: "dark" });
const pillDoNotUse = objectWithClassName({
  className: [
    /** @deprecated Use 'umd-pill-list' instead */
    "umd-pills"
  ],
  marginTop: `-${spacing.min}`,
  "& > *": {
    backgroundColor: color.gray.lightest,
    display: "inline-block",
    padding: `${spacing.min} ${spacing.xs}`,
    marginBottom: "0",
    marginTop: spacing.min
  },
  "& a:hover, &:focus": {
    textDecoration: "underline"
  }
});
export {
  composePill,
  pillDoNotUse,
  pillList,
  pillListDark
};
//# sourceMappingURL=cluster.js.map
